import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {BREADCRUMBS_DEVICE_OPERATIONAL_STATISTIC_BY_DEVICES} from "./constants/breadcrumbs";
import {
    DeviceOperationalStatisticByDevicesLazy
} from "@containers/device/containers/deviceOperationalStatistic/DeviceOperationalStatisticByDevices.lazy";


const DeviceOperationalStatisticByDevicesPage = () => {
    return (
        <PageLayout
            breadcrumbs={BREADCRUMBS_DEVICE_OPERATIONAL_STATISTIC_BY_DEVICES}
        >
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <DeviceOperationalStatisticByDevicesLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default DeviceOperationalStatisticByDevicesPage;